import { Serv_send } from './Serv.socketClient'
import type { Sync_Params } from '../Sync/Sync.standardSync'
import type { Endpoints, PostWithContent } from '../../../shared/domain/posts/types.no-deps'
import type { Replace } from '../../../shared/lib/typeHelpers.no-deps'

type ServerResponse = Endpoints.SyncOutput
export type ServSyncPostsResponse = Replace<ServerResponse, { syncTime: Date }>
type SyncPostsParams = Sync_Params & {
    unitIds?: number[]
    excludeFiles?: boolean
    includeLanguage?: boolean
    requireUnitEventPosts?: boolean
}

export async function Serv_syncPosts(
    posts: PostWithContent[],
    params: SyncPostsParams
): Promise<ServSyncPostsResponse> {
    const lastSyncTime = params.lastSyncTime.toISOString()
    const requireUnitEventPosts = params.requireUnitEventPosts ?? false
    const response = (await Serv_send('posts.sync', {
        posts,
        ...params,
        lastSyncTime,
        includeNewPostTypes: true,
        excludeFiles: true,
        includeLanguage: true,
        requireUnitEventPosts,
    })) as ServerResponse
    return { ...response, syncTime: new Date(response.syncTime) }
}
